export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];

export const DEFAULT_ROWS_PER_PAGE = 25;
